export default "<div *ngIf=\"show\">\r\n  <div id=\"overlay\">\r\n    <div class=\"spinner\"></div>\r\n  </div>\r\n</div>\r\n"